import { render, staticRenderFns } from "./UnionpayH5.vue?vue&type=template&id=96873a44&scoped=true&"
import script from "./UnionpayH5.vue?vue&type=script&lang=js&"
export * from "./UnionpayH5.vue?vue&type=script&lang=js&"
import style0 from "./UnionpayH5.vue?vue&type=style&index=0&id=96873a44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96873a44",
  null
  
)

export default component.exports